import { State, Action, StateContext, Selector } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { Alert } from 'app/models/dto/alert.model';
import { CreateNewBorrowerAlert, DismissBorrowerAlert, ClearBorrowerAlertsStore } from './borrower-alerts.actions';

export class BorrowerAlertsStateModel {
  borrowerAlerts: Alert[] | [];
}

@State<BorrowerAlertsStateModel>({
  name: 'borrowerAlerts',
  defaults: {
    borrowerAlerts: []
  }
})
@Injectable()

export class BorrowerAlertsState {

  @Selector()
    static borrowerAlerts(state: BorrowerAlertsStateModel) {
    return state.borrowerAlerts;
  }

  constructor() {}

  @Action(CreateNewBorrowerAlert)
  createNewBorrowerAlert({ getState, patchState }: StateContext<BorrowerAlertsStateModel>, { alert }: CreateNewBorrowerAlert) {
    patchState({ borrowerAlerts: [ ...getState().borrowerAlerts, alert ]});
  }

  @Action(DismissBorrowerAlert)
  dismissBorrowerAlert({ getState, patchState }: StateContext<BorrowerAlertsStateModel>, { alert }: DismissBorrowerAlert) {
    const alertsCopy = [ ...getState().borrowerAlerts ];
    const updatedAlerts = alertsCopy.filter(a => a.level !== alert.level && a.message !== alert.message);
    patchState({ borrowerAlerts: updatedAlerts });
  }

  @Action(ClearBorrowerAlertsStore)
  clearBorrowerAlertsStore({ patchState }: StateContext<BorrowerAlertsStateModel>, {}: ClearBorrowerAlertsStore) {
    patchState({ borrowerAlerts: [] });
  }
}
